import { Container, Row, Col, Form } from "react-bootstrap";
import FloatingLabelInput from "../Generic/FloatingLabelInput";

const ProfileSummaryCard = ({
  form,
  setForm,
  errors = {},
  isEditing,
  setIsEditing,
  primaryExperience,
  loading,
  onSave,
  onCancel,
  avatarUrl,
  onFileChange,
  readOnly,
}) => {
  return (
    <div className="profile-summary-card">
      {/* AVATAR */}
      <div className="avatar-row-wrapper">
        <img src={avatarUrl} alt="Avatar" className="summary-avatar" />

        {isEditing && (
          <div className="avatar-upload-right">
            <label className="change-photo-label">Change photo</label>
            <input
              type="file"
              accept="image/*"
              className="change-photo-input"
              onChange={onFileChange}
            />
          </div>
        )}
      </div>

      <Container>
        <Row className="align-items-start">
          {/* NAME + EDIT */}
          <Col md={8}>
            <div className="name-section">
              {!isEditing ? (
                <>
                  {/* NAME BLOCK WITH EDIT (MOBILE SAFE) */}
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h1 className="profile-name mb-0">
                        {form.firstName} {form.lastName}
                      </h1>
                      <p className="profile-title">
                        {primaryExperience?.jobTitle || "Member"}
                      </p>
                    </div>

                    {!readOnly && (
                      <div className="profile-summary-edit-btn-wrapper">
                        <button
                          type="button"
                          className="link-button edit-top-btn text-primary"
                          onClick={() => setIsEditing(true)}
                        >
                          Edit
                        </button>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  {/* EDIT MODE */}
                  <Row className="mb-2">
                    <Col md={6}>
                      <Form.Group>
                        <FloatingLabelInput
                          label="First Name *"
                          type="text"
                          value={form.firstName || ""}
                          onChange={(e) =>
                            setForm((prev) => ({
                              ...prev,
                              firstName: e.target.value,
                            }))
                          }
                        />
                        {errors.firstName && (
                          <div className="text-danger small mt-1">
                            {errors.firstName}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <FloatingLabelInput
                          label="Last Name *"
                          type="text"
                          value={form.lastName || ""}
                          onChange={(e) =>
                            setForm((prev) => ({
                              ...prev,
                              lastName: e.target.value,
                            }))
                          }
                        />
                        {errors.lastName && (
                          <div className="text-danger small mt-1">
                            {errors.lastName}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <p className="profile-title">
                    {primaryExperience?.jobTitle || "Member"}
                  </p>
                </>
              )}
            </div>
          </Col>

          {/* SAVE / CANCEL (DESKTOP RIGHT, MOBILE BELOW) */}
          <Col
            md={4}
            className="d-flex justify-content-md-end justify-content-start"
          >
            {!readOnly && isEditing && (
              <div className="edit-btn-row d-flex gap-2 ms-md-auto">
                <button
                  type="button"
                  className="auth-btn-compact bg-primary text-white"
                  onClick={onSave}
                  disabled={loading}
                >
                  Save
                </button>

                <button
                  type="button"
                  className="auth-btn-compact auth-btn-secondary"
                  onClick={onCancel}
                >
                  Cancel
                </button>
              </div>
            )}
          </Col>
        </Row>

        {/* META ROW */}
        <Row className="summary-meta-row">
          <Col md={4} className="summary-meta-item">
            <div className="meta-label">Location</div>
            <div className="meta-value">
              {form.address?.city || "Not added"}
            </div>
          </Col>

          <Col md={4} className="summary-meta-item">
            <div className="meta-label">Year of Experience</div>
            <div className="meta-value">
              {typeof primaryExperience?.years === "number"
                ? `${primaryExperience.years} years`
                : "Not added"}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProfileSummaryCard;
